import type { Wrex } from '@lumapps/wrex/types';

import { EMBEDDED_MAP } from '../constants';
import type { EmbeddedMapElement } from '../types';

/** Create an embedded map element */
export const createEmbeddedMap = (attributes: Wrex.ElementAttributes<EmbeddedMapElement>): EmbeddedMapElement => {
    return { type: EMBEDDED_MAP, ...attributes, children: [{ text: '' }] };
};
